import { ChevronLeft, ChevronRight } from "lucide-react";

interface Props {
  page: number;
  total: number;
  pageSize: number;
  onPageChange: (newPage: number) => void;
  entityName: string;
}

/**
 * Compact Firebase-style pagination footer:
 * "1–8 of 24    ‹  ›"
 */
export function PaginationFooter({ page, total, pageSize, onPageChange, entityName }: Props) {
  if (total === 0) return null;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, total);
  const canPrev = safePage > 1;
  const canNext = safePage < totalPages;

  return (
    <footer className="home-pagination-footer" aria-label={`${entityName} pagination`}>
      <span className="home-pagination-label" data-testid={`${entityName.toLowerCase()}-pagination-label`}>
        {start}–{end} of {total}
      </span>
      <div className="home-pagination-buttons">
        <button
          type="button"
          data-testid={`${entityName.toLowerCase()}-page-prev`}
          className="home-pagination-btn"
          disabled={!canPrev}
          onClick={() => onPageChange(safePage - 1)}
          aria-label={`Previous ${entityName} page`}
          title="Previous page"
        >
          <ChevronLeft size={16} aria-hidden />
        </button>
        <button
          type="button"
          data-testid={`${entityName.toLowerCase()}-page-next`}
          className="home-pagination-btn"
          disabled={!canNext}
          onClick={() => onPageChange(safePage + 1)}
          aria-label={`Next ${entityName} page`}
          title="Next page"
        >
          <ChevronRight size={16} aria-hidden />
        </button>
      </div>
    </footer>
  );
}
